import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-unternehmens-partner',
  standalone: true,
  imports: [],
  templateUrl: './unternehmens-partner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './unternehmens-partner.component.scss'
})
export class UnternehmensPartnerComponent {

}
